export const SET_BUSINESS = 'SET_BUSINESS'
export const SET_BUSINESSES = 'SET_BUSINESSES'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_BUSINESS_CONTACTS = 'SET_BUSINESS_CONTACTS'
export const SET_BUSINESS_CHECKED = 'SET_BUSINESS_CHECKED'
export const CLEAR_BUSINESSES = 'CLEAR_BUSINESSES'
export const SET_SEARCH_BUSINESSES = 'SET_SEARCH_BUSINESSES'



// WEBPACK FOOTER //
// ./src/store/modules/businesses/types.js